import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IDaylightActionProps } from "./DaylightAction.props";

const styles = {
  primary: "border-ink bg-ink text-daylight hover:border-cobalt hover:bg-cobalt",
  secondary: "border-ink/70 bg-transparent text-ink hover:border-ink hover:bg-sky",
  ghost:
    "border-transparent bg-transparent text-cobalt underline underline-offset-4 hover:underline-offset-8",
  destructive: "border-destructive bg-destructive text-daylight hover:border-ink hover:bg-ink",
} as const;

export const DaylightAction = ({ action, className }: IDaylightActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "group inline-flex min-h-11 items-center justify-center gap-3 rounded-full border px-5 py-3 font-daylight-body text-sm font-semibold leading-[1.4] transition-[background-color,border-color,color,text-underline-offset] duration-200 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      <span>{action.label}</span>
      <span
        aria-hidden="true"
        className="text-base leading-none transition-transform duration-200 ease-out group-hover:translate-x-1"
      >
        →
      </span>
    </Link>
  );
};

DaylightAction.displayName = "Content::DaylightAction";
